export default {
    currentSelection: {
        title: 'You have selected the items <br /> listed below: ',
        unitsUsed: 'selected units',
        unitsLeft: 'units <small>left</small>'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/modal.js